import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';

const workersUrl = 'csb/workflows/workers/all';

export const useCsbWorkers = () => {
  return useQuery<string[]>({
    queryFn: async () => {
      const response = await apiClient.get<string[][]>(workersUrl);
      return Array.from(new Set(response.data.flat().filter(Boolean)));
    },
    queryKey: ['csb-workers'],
  });
};
